import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Select } from '../models/select';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class FertilizersService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  getCombo(): Observable<Select[]> {
    return this.http.get<Select[]>(`${this.getUrl('Fertilizers/GetCombo/')}`);
  }

  search(description: string): Observable<Select[]> {
    return this.http.get<Select[]>(`${this.getUrl("Fertilizers/Search")}/${description}`);
  }
}
